<template>
  <div v-if="hasGeography" class="px-3 py-2 border-top">
    <div class="map">
      <GoogleMap
        class="map__graphic"
        :geography="geography"
        style="height: 300px"
        :recipientId="recipientId"
      />
      <div
        v-if="hasHatGeography"
        class="map__pinnacle"
        @click="openPinnacleMap"
      >
        <img src="/images/pmap.png" alt="pinnacle map" />
      </div>
    </div>
    <div class="text-center">
      <h6 class="pt-4 mb-0">{{ normalizedAddress }}</h6>
      <small class="text-muted ml-2"><em>updated {{ updatedAt }}</em></small>
    </div>
    <RebidRequestButton
      v-if="currentConversation.status === 'active' && currentConversation.tcc_session && currentConversation.tcc_session.session_id"
      :conversationId="currentConversation.conversation_id"
      :sessionId="currentConversation.tcc_session.session_id"
      class="mt-3"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "../../events/eventBus";
import GoogleMap from "../GoogleMap";
import moment from "moment-timezone";
import LocationRequestButton from "../action_buttons/LocationRequestButton";
import RebidRequestButton from "../action_buttons/RebidRequestButton";

export default {
  props: {
    recipientId: String,
    conversationId: String,
    recipientLabel: String,
  },
  components: {
    GoogleMap,
    RebidRequestButton,
    LocationRequestButton,
  },
  data() {
    return {
      altimeter: null,
      geography: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("conversations", ["currentConversation", "activeConversations"]),
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency"]),
    ...mapGetters("pinnacle", ["isPinnacleMapShowing", "isPinnacleSDKLoaded"]),
    hasGeography() {
      return this.geography && this.geography.length;
    },
    hasHatGeography() {
      return this.geography.filter(geo => geo.hat).length > 0;
    },
    normalizedAddress() {
      if (this.hasGeography) {
        return this.geography[0].normalized_address;
      }
      return "";
    },
    updatedAt() {
      if (this.hasGeography) {
        return this.getLastLocationTime(this.geography[0].updated_at);
      }
      return "";
    },
  },
  methods: {
    async fetchGeography(recipientId) {
      this.isLoading = true;

      const params = {};
      if (this.conversationId) {
        params['conversationId'] = this.conversationId;
      }

      const resp = await this.$ConveyApi.locationsApi.getGeolocations({ params });
      this.geography = resp.data.data;
      this.isLoading = false;
    },
    getLastLocationTime(t) {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedTime = moment.utc(t, "x").tz(tz).fromNow();
        return formattedTime;
      } catch (e) {
        return t;
      }
    },
    addLocation(data) {
      const currentConversation = this.activeConversations.find(convo => convo.conversation_id === this.conversationId);
      if (currentConversation && currentConversation.recipients && currentConversation.recipients.length > 0) {
        const recipientIds = currentConversation.recipients.map(i => i.recipient_id);
        if (recipientIds.includes(data.recipient_id)) {
          this.geography = [data].concat(this.geography);
          if (this.isPinnacleMapShowing && this.hasHatGeography) {
            const { hat, lat, lng, ten_dlc } = data;
            const userData = {
              ...data,
              id: ten_dlc,
              hat: hat == null ? 0 : hat,
              lat,
              lng,
              elf: null,
              ts: data.updated_at || data.ts
            };
            EventBus.$emit("updatePinnacleMapLocation", userData);
          }
        }
      }
    },
    openPinnacleMap() {
      EventBus.$emit("openPinnacleMapModal", {
        geography: this.geography.map(geo => {
          const { hat, lat, lng, ten_dlc } = geo;
          return {
            ...geo,
            id: ten_dlc,
            hat: hat == null ? 0 : hat,
            lat,
            lng,
            elf: null,
            elf: null,
            ts: geo.updated_at || geo.ts,
          }
        }),
        recipientId: this.recipientId
      });
    },
    replayMapping() {
      if (this.isPinnacleMapShowing) {
        if (!this.instanceForReplay) {
          let counter = 0;
          const geography = this.geography.map(geo => {
            return {
              ...geo,
              id: geo.ten_dlc,
              elf: null,
              ts: geo.updated_at || geo.ts,
            }
          }).reverse();
          this.instanceForReplay = setInterval(() => {
            const geo = geography[counter];
            EventBus.$emit("updatePinnacleMapLocation", {
                id: geo.id,
                hat: geo.hat || 0,
                lat: geo.lat,
                lng: geo.lng,
                elf: null,
            });
            if (counter == geography.length - 1) {
              counter = 0;
            } else {
              counter += 1;
            }
          }, 500);

        } else {
          clearInterval(this.instanceForReplay);
          this.instanceForReplay = null;
        }
      } else if (this.instanceForReplay) {
        clearInterval(this.instanceForReplay);
        this.instanceForReplay = null;
      }
    },
  },
  async created() {
    if (this.currentAgency && this.recipientId) {
      this.fetchGeography(this.recipientId);
    }

    EventBus.$on("addRecipientGeolocation", this.addLocation);
  },
  beforeDestroy() {
    EventBus.$off("addRecipientGeolocation", this.addLocation);
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
}

.map {
  position: relative;
  width: 100%;
  height: 300px;

  &__graphic {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  &__pinnacle {
    position: absolute;
    top: 10px;
    left: 180px;
    width: 40px;
    height: 40px;
    z-index: 2;
    cursor: pointer;

    > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
